import { ReducedFundData } from './fund.model';
import { Pagination } from './pagination.model';
import { Representative } from './representative.model';
import { SelectData } from './select-input.model';

export interface DraweeCreationFields {
  id?: number;
  nome: string;
  cnpjcpf: string;
  tipoInscricaoEstadualIsento: boolean;
  inscricaoEstadual: string;
  inicioRelacionamento: Date;
  terminoRelacionamento: Date;
  faturamentoAnual: string;
  endereco: string;
  numero: string;
  complemento: string;
  cep: string;
  bairro: string;
  cidade: string;
  telefoneDDD: string;
  faxDDD: string;
  conglomeradoEconomico: string;
  representantes: Representative[];
  porte: SelectData;
  classificacaoRisco: SelectData;
  tipoSociedade: SelectData;
  idFundo: SelectData;
  assinaSozinho: boolean;
  assinaEndosso: boolean;
  assinaTermoCessao: boolean;
  emiteDuplicata: boolean;
  tipoPessoa: number;
  uf: SelectData;
  email: string;
  assinaturaProprioSacado: boolean;
}

export interface DraweeBody
  extends Omit<
    DraweeCreationFields,
    'classificacaoRisco' | 'tipoSociedade' | 'porte' | 'fundo' | 'uf'
  > {
  porte: number;
  classificacaoRisco: number;
  tipoSociedade: number;
  fundo: string;
  uf: string;
  estado: string;
}

export interface PaginatedDrawees extends Pagination {
  items: ReducedFundData[];
}
